const { PollStats } = require("Scripts/gayl/poll-stats.js")

module.exports = Poll;

function Poll() {
	var self = this;

	this.init = function() {
		this.rootElement = $('.js-poll-widget');
		this.ui = {
			notVotedSection: $('.js-poll-unvoted'),
			votedSection: $('.js-poll-voted'),
			voteOptions: $('.js-poll-vote'),
			chart: $('.js-poll-stats-chart')
		};
		this.state = {
			hasVoted: this.rootElement.attr('data-has-voted') === "true",
			pollId: this.rootElement.attr('data-poll-id')
		};
		this.bindEventHandlers();

		if(this.state.hasVoted) {
			this.initChart();
		}
	};

	this.bindEventHandlers = function() {
		this.ui.voteOptions.on('click', this.onVote);
	};

	/**
	 * Called when the user selects an option.
	 */
	this.onVote = function(e) {
		var clickedEl = $(this);
		var answerId = clickedEl.attr('data-poll-answer-id');
		var oldBtnText = clickedEl.text();
		clickedEl.prop('disabled', true).text('Loading...');

		self.recordVote(self.state.pollId, answerId).then(function(resp) {
			if(resp.success) {
				self.onVoteSuccess(resp.payload.pollStats);
			} else {
				self.onVoteFailed();
			}
		}).always(function() {
			clickedEl.prop('disabled', false).text(oldBtnText);
		});
	};

	this.onVoteFailed = function() {
		// todo: implement this!
	};

	this.onVoteSuccess = function(pollStats) {
		self.ui.notVotedSection.hide();
		self.ui.votedSection.show();
		self.initChart(pollStats); // Init the chart afterwards so user sees the animation
	};

	/**
	 * Makes an AJAX request to record a user's vote.
	 */
	this.recordVote = function(pollId, pollAnswerId) {
		return $.ajax({
			method: 'POST',
			url: '/poll/' + pollId + '/vote/' + pollAnswerId
		});
	};

	/**
	 * This is called in two places:
	 * - On page load if a user has already voted
	 * - After a user has voted for the first time
	 *
	 * pollStats is an object used to supply data to the chart. It's only ever defined if the user
	 * has just voted.
	 */
	this.initChart = function(pollStats) {
		if(pollStats) {
			new PollStats(this.ui.chart, {
				answers: pollStats.answers,
				percentages: pollStats.percentages,
				selectedAnswer: pollStats.userEntry.answer.value
			});
		} else {
			new PollStats(this.ui.chart);
		}
	};

	this.init();
}